<script setup lang="ts">
import { computed } from 'vue'
// types
import type { StrapiFooterImageLink } from '@ts-strapi/interfaces'
// helpers
import { resolveStrapiMediaUrl } from '@helpers/strapi-media'
// components
import { LinkBase } from '@UI/Links/LinkBase'

defineOptions({
  name: 'FooterBadgeGrid',
})

const props = defineProps<{
  items: StrapiFooterImageLink[]
  variant: 'payment' | 'trust'
}>()

const { strapi } = useRuntimeConfig().public

const refVariantClass = computed<string>(() => `footer-badge-grid--${props.variant}`)
</script>

<template>
  <div
    class="footer-badge-grid"
    :class="refVariantClass"
  >
    <template
      v-for="item in items"
      :key="item.image.id"
    >
      <LinkBase
        v-if="item.url"
        class="footer-badge-grid__item footer-badge-grid__item--linked"
        :link="{ label: item.alt, url: item.url, newTab: item.newTab }"
      >
        <img
          class="footer-badge-grid__img"
          :src="resolveStrapiMediaUrl(item.image.url, strapi.publicUrl)"
          :alt="item.alt"
          :width="item.image.width"
          :height="item.image.height"
          loading="lazy"
          decoding="async"
        >
      </LinkBase>
      <span
        v-else
        class="footer-badge-grid__item"
      >
        <img
          class="footer-badge-grid__img"
          :src="resolveStrapiMediaUrl(item.image.url, strapi.publicUrl)"
          :alt="item.alt"
          :width="item.image.width"
          :height="item.image.height"
          loading="lazy"
          decoding="async"
        >
      </span>
    </template>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Footers/FooterBadgeGrid.scss" />
